export enum SideNavContactIds {
	CONTACT = "CONTACT",
	SERVICE_CLIENT = "SERVICE_CLIENT",
	SUGGERER_UNE_IDEE = "SUGGERER_UNE_IDEE",
}
